import type {ReactElement} from 'react';
import React from 'react';
import {BaseItemInvertOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-invert-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromEffectsOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveSlideItem';

export function SlideshowItemInvertOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const invert = useGetKeyFromEffectsOfActiveSlideItem('invert');

  if (!activeItem || !activeSlideUID) {
    throw new Error('Active item or active slide is not defined in slideshow item effects options');
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected active item to be of type slideshow, got ${activeItem.gitype} instead`);
  }

  if (invert === undefined) {
    throw new Error('blackandwhite is undefined for active slide item');
  }

  const onToggleOption = (): void => {
    void activeItem.updateSlideFromObject(activeSlideUID, {
      effects: {
        invert: !invert,
      },
    });
  };

  return <BaseItemInvertOption isChecked={invert} onToggleOption={onToggleOption} />;
}
